module.exports = __webpack_public_path__ + "img/SKLB-Entregas.7ef1aeca.png";